module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/stores/stores-show/stores-show.component.scss
// module id = ./src/app/views/setting/stores/stores-show/stores-show.component.scss
// module chunks = main